<div class="premium">
  <ds-currency [currency]="amount"></ds-currency>
  <div class="term">
    {{ term }}
  </div>
</div>
